import styled from '@emotion/styled';
import {Img as ImgUI, SmallTitle, MainTitle} from 'ui';
import {colors} from 'ui/config';

export const Container = styled('a')({
  position: 'relative',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'start',
  marginBottom: 10,
  // paddingBottom: 60,
  height: 152,
  color: 'white',
});

export const Img = styled(ImgUI)({
  width: 334,
  // height: 215,
  objectFit: 'contain',
  backgroundImage: 'linear-gradient(180deg, rgba(56,40,24,0.00) 43%, #382818 100%)',
  opacity: 0.8,
  // paddingLeft: 20,
  // paddingRight: 20,
});

export const InfoContainer = styled('div')({
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 'auto',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
});

export const SmallTitleWhite = styled(SmallTitle)({
  color: colors.white,
  marginTop: 4,
  width: 'max-content',
  marginBottom: 1,
});

export const BigTitle = styled(MainTitle)({
  fontSize: 26,
  lineHeight: '28px',
  width: 'max-content',
});
